import { createFileRoute } from '@tanstack/react-router'
import { RouteNewPage } from '@/features/routes/route-new-page'

export const Route = createFileRoute('/_authenticated/routes/new')({
  component: RouteNewPage,
})
